import { render, staticRenderFns } from "./AboutUsProfile.vue?vue&type=template&id=326f6706&scoped=true&"
import script from "./AboutUsProfile.vue?vue&type=script&lang=js&"
export * from "./AboutUsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326f6706",
  null
  
)

export default component.exports